import PropTypes from 'prop-types';

import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';
import { Button, Typography } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

const LikesButton = (props) => {
  const { t } = useTransl();
  const { onClick, isLiked, likesCount, disabled } = props;
  const label = `${likesCount} ${t('title.like', { count: likesCount })}`;

  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      sx={{ display: 'flex', gap: '0.5rem', color: 'inherit' }}
    >
      {isLiked ? (
        <FavoriteIcon color="secondary" />
      ) : (
        <FavoriteBorderRoundedIcon />
      )}
      <Typography>{label}</Typography>
    </Button>
  );
};

LikesButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isLiked: PropTypes.bool.isRequired,
  likesCount: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default LikesButton;
